<template>
    <div>
        <page-hero
            :heroImage="heroImage"
            :pageTitle="pageTitle"
            :imageAltText="imageAltText"
        ></page-hero>

        <v-container style="max-width: 1185px">
            <page-subheading title="Get in Touch"></page-subheading>

            <v-row
                align="start"
                justify="center"
            >
                <v-col sm="8" md="4">
                    <contact-card
                        title="Corporate Headquarters"
                        :image="coporateHeadquartersImage"
                        subtitle="Findlay Ohio"
                        :contained="true"
                        addressLine1="2030 Production Dr"
                        addressLine2="Findlay, OH 45840"
                        phoneNumber="(419) 423-9552"
                    ></contact-card>
                </v-col>

                <v-col sm="8" md="4">
                    <contact-card
                        title="Anti Vibration Division"
                        :image="antiVibrationDivisionImage"
                        subtitle="Upper Sandusky Ohio"
                        addressLine1="235 Commerce Way"
                        addressLine2="Upper Sandusky, OH 43351"
                        phoneNumber="(419) 294-6989"
                    ></contact-card>
                </v-col>

                <!-- <v-col sm="8" md="4">
                    <contact-card
                        title="Sales Department"
                        :image="salesDepartmentImage"
                        subtitle="General Manager - Kaz Tanaka"
                        :contained="true"
                        addressLine1="2030 Production Dr"
                        addressLine2="Findlay, OH 45840"
                        phoneNumber="(419) 423-9552"
                    ></contact-card>
                </v-col> -->

            </v-row>
        </v-container>
    </div>
</template>

<script>
import ContactCard from '@/components/contact-us/ContactCard.vue'
import PageHero from '@/components/PageHero.vue'
import PageSubheading from '@/components/PageSubheading.vue'

export default {
    components: {
        'contact-card': ContactCard,
        'page-hero': PageHero,
        'page-subheading': PageSubheading
    },
    name: 'ContactUsView',
    data: () => {
        return {
            heroImage: require('@/assets/contact-us/contact_us_hero1800x1200.jpg'),
            pageTitle: "Contact Us",
            coporateHeadquartersImage: require('@/assets/contact-us/corporate_office_sign370x278.jpg'),
            antiVibrationDivisionImage: require('@/assets/contact-us/prospira_upper_sandusky_sign370x250.jpg'),
            salesDepartmentImage: require('@/assets/mark_logo.png'),
            imageAltText: "Stock image of individual using a phone"
        }
    }
}
</script>
